export default __webpack_public_path__ + "static/media/file-video.0157ffff.svg";